import styled, { css } from 'styled-components';
import { space } from 'styled-system';

const BreadCrumbStyles = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  line-height: 18px;

  @media screen and (max-width: 1179px) {
    display: none;
  }

  ${props =>
    !props.fluid &&
    css`
      li {
        max-width: 300px;

        @media screen and (max-width: 1023px) {
          max-width: 200px;
        }
      }
    `}
`;

const ItemStyles = styled.li`
  ${space}

  display: inline-flex;
  align-items: center;

  color: ${props => props.theme.colors.primary};
  font-weight: bold;

  &:not(:last-child) {
    margin-right: ${props => props.theme.space[1]};
    padding-right: calc(7px + ${props => props.theme.space[1]});
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 0.4375rem;
      height: 0.5625rem;
      ${props => css`
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='7' height='9' viewBox='0 0 7 9'%3e%3cpolyline fill='none' stroke='${props.theme.colors.primary.replace(
          '#',
          '%23',
        )}' stroke-width='2' points='14 12 18 15.769 14.22 19.333' transform='translate(-13 -11)'/%3e%3c/svg%3e ");
      `}
      right: 0;
      top: 50%;
      margin-top: -0.3125rem;
    }
  }
`;

BreadCrumbStyles.ItemStyles = ItemStyles;

export default BreadCrumbStyles;
